import React from 'react'
import { Linkedin, Mail, MapPin, Phone } from 'lucide-react'
import { personalInfo, socialLinks } from '../data/portfolio'

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-slate-900 dark:bg-slate-950 text-white">
      <div className="container-max py-12">
        <div className="grid md:grid-cols-3 gap-8">
          {/* About Section */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold">{personalInfo.name}</h3>
            <p className="text-slate-300 leading-relaxed">
              {personalInfo.title} with expertise in backend development, AI applications, and cloud architecture.
            </p>
            <div className="flex space-x-4">
              <a
                href={socialLinks.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-slate-800 hover:bg-blue-600 rounded-lg transition-colors duration-200"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a
                href={`mailto:${socialLinks.email}`}
                className="p-2 bg-slate-800 hover:bg-blue-600 rounded-lg transition-colors duration-200"
                aria-label="Email"
              >
                <Mail size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold">Quick Links</h3>
            <div className="space-y-2">
              <a href="#about" className="block text-slate-300 hover:text-white transition-colors duration-200">
                About Me
              </a>
              <a href="#experience" className="block text-slate-300 hover:text-white transition-colors duration-200">
                Experience
              </a>
              <a href="#projects" className="block text-slate-300 hover:text-white transition-colors duration-200">
                Projects
              </a>
              <a href="#skills" className="block text-slate-300 hover:text-white transition-colors duration-200">
                Skills
              </a>
              <a href="#contact" className="block text-slate-300 hover:text-white transition-colors duration-200">
                Contact
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-slate-300">
                <Mail size={18} />
                <a 
                  href={`mailto:${socialLinks.email}`}
                  className="hover:text-white transition-colors duration-200"
                >
                  {socialLinks.email}
                </a>
              </div>
              <div className="flex items-center space-x-3 text-slate-300">
                <Phone size={18} />
                <a 
                  href={`tel:${socialLinks.phone}`}
                  className="hover:text-white transition-colors duration-200"
                >
                  {socialLinks.phone}
                </a>
              </div>
              <div className="flex items-center space-x-3 text-slate-300">
                <MapPin size={18} />
                <span>{socialLinks.location}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-8 pt-8 text-center">
          <p className="text-slate-400">
            &copy; {currentYear} {personalInfo.name}. All rights reserved.
          </p>
          <p className="text-slate-500 text-sm mt-2">
            Built with React, TypeScript, and Tailwind CSS
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer